import '../../App.css';
import './UserAccount.css';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Profile from '../user-account/profile';
import AccountStatement from '../user-account/account-statement';
import ActivityLog from '../user-account/activity-log';
// import ProfitLoss from '../user-account/profit-loss';
import BetsList from '../user-account/bets-list';
import ProfitLoss from '../my-report/all-event-market-wise-pl';

const ACCOUNT_TABS = [
    {
        id: 'profile',
        label: 'My Profile',
        icon: '👤',
    },
    {
        id: 'bet-history',
        label: 'Bet History',
        icon: '📋',
    },
    {
        id: 'profit-loss',
        label: 'Account Statement',
        icon: '📊',
    },
    {
        id: 'account-statement',
        label: 'Deposit & Withdraw',
        icon: '₹',
    },
    {
        id: 'activity-log',
        label: 'Activity Log',
        icon: '🕘',
    },
];

function UserAccount() {
    const location = useLocation();
    useEffect(() => {
        const routeState =
            location?.state || {};

        setActiveTab(
            routeState.activeTab || 'profile'
        );

        const routeId = routeState.id;

        if (
            routeId &&
            typeof routeId === 'object'
        ) {
            set_id(
                routeId.x ||
                routeId._id ||
                ''
            );
        } else {
            set_id(routeId || '');
        }
    }, [location]);
    const [activeTab, setActiveTab] =
        useState('profile');

    const [_id, set_id] = useState('');

    return (
        <main className="user-account-page">
            <section className="user-account-shell">
                <div className="user-account-heading">
                    <div className="user-account-heading-content">
                        <span className="user-account-heading-icon">
                            👤
                        </span>

                        <div>
                            <h1>My Account</h1>

                            <p>
                                Manage user profile,
                                transactions and account
                                activity
                            </p>
                        </div>
                    </div>
                </div>

                <div className="user-account-layout">
                    <aside className="user-account-sidebar">
                        <div className="user-account-sidebar-title">
                            Account Menu
                        </div>

                        <nav
                            className="user-account-navigation"
                            aria-label="Account sections"
                        >
                            {ACCOUNT_TABS.map(
                                (tab) => (
                                    <button
                                        key={tab.id}
                                        type="button"
                                        className={
                                            activeTab ===
                                                tab.id
                                                ? 'active'
                                                : ''
                                        }
                                        onClick={() =>
                                            setActiveTab(
                                                tab.id
                                            )
                                        }
                                    >
                                        <span
                                            className="user-account-tab-icon"
                                            aria-hidden="true"
                                        >
                                            {tab.icon}
                                        </span>

                                        <span>
                                            {tab.label}
                                        </span>
                                    </button>
                                )
                            )}
                        </nav>
                    </aside>

                    <section className="user-account-content">
                        {/* <div className="user-account-content-title">
                            <h2>
                                {
                                    ACCOUNT_TABS.find(
                                        (tab) =>
                                            tab.id ===
                                            activeTab
                                    )?.label
                                }
                            </h2>
                        </div> */}

                        <div className="user-account-component">
                            {activeTab === 'profile' && (
                                <Profile user_id={_id} />
                            )}

                            {activeTab ===
                                'account-statement' && (
                                    <AccountStatement
                                        user_id={_id}
                                    />
                                )}

                            {activeTab ===
                                'activity-log' && (
                                    <ActivityLog
                                        user_id={_id}
                                    />
                                )}

                            {activeTab ===
                                'profit-loss' && (
                                    <ProfitLoss
                                        user_id={_id}
                                    />
                                )}

                            {activeTab ===
                                'bet-history' && (
                                    <BetsList
                                        user_id={_id}
                                    />
                                )}
                        </div>
                    </section>
                </div>
            </section>
        </main>
    );
}

export default UserAccount;
